export default [
  {
    dataType: 1,
    attributePrototypeId: 1,
    label: "Imię Nazwisko",
    value: "Jan Kowal",
    isPrintable: true,
    isRequired: false,
    ordinal: 1,
  },
  {
    dataType: 1,
    attributePrototypeId: 2,
    label: "Numer biletu",
    value: null,
    isPrintable: true,
    isRequired: true,
    ordinal: 2,
  },
  {
    dataType: 8,
    attributePrototypeId: 4,
    label: "Wylot",
    value: null,
    isPrintable: true,
    isRequired: false,
    ordinal: 3,
  },
];
